<template>
  <b-row class="no-gutters ml-n3">
    <b-col class="col-12 col-md-6 col-lg-4 pl-3">
      <search-input
        v-model="searchInput"
        label="search"
        :placeholder="$t('page.groups.searchPlaceholder')"
        @search="search"
      ></search-input>
    </b-col>
    <!-- <b-col hidden class="col-12 col-md-6 col-lg-4 pl-3">
      <form-select v-model="filterGroupStatus" label="status">
        <b-form-select-option :value="null">
          {{ $t("all") }}
        </b-form-select-option>
        <b-form-select-option
          v-for="(status, index) in groupStatusOptions"
          :key="index"
          :value="status"
        >
          {{ $t("page.groups.status." + status) }}
        </b-form-select-option>
      </form-select>
    </b-col> -->
  </b-row>
</template>

<script>
import SearchInput from "../Base/BaseSearchInput";
// import FormSelect from "../Base/BaseFormSelect";
export default {
  components: {
    SearchInput
    // FormSelect
  },
  data() {
    return {
      searchInput: ""
      // groupStatusOptions: ["active", "inactive"]
    };
  },
  mounted() {
    this.searchInput = this.filterSearch;
  },
  computed: {
    filterSearch: {
      get() {
        return this.$store.getters["groups/getFilterSearch"];
      },
      set(value) {
        this.$store.commit("groups/SET_FILTER_SEARCH", value);
      }
    }
    // filterGroupStatus: {
    //   get() {
    //     return this.$store.getters["groups/getFilterGroupStatus"];
    //   },
    //   set(value) {
    //     this.$store.commit("groups/SET_FILTER_GROUP_STATUS", value);
    //     this.retrieveGroups();
    //   }
    // }
  },
  methods: {
    search() {
      this.filterSearch = this.searchInput;
      this.retrieveGroups();
    },
    async retrieveGroups() {
      try {
        this.$store.commit("loader/SET_LOADER", {});
        await this.$store.dispatch("groups/retrieveGroups", {
          hasPagination: true,
          initial: true
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("loader/RESET");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
